module.exports = __webpack_public_path__ + "static/MT_Benefit-08.aa7b5fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefit-icons/MT_Benefit-08.png
// module id = 1468
// module chunks = 169858455373905